import { render } from "./Team.vue?vue&type=template&id=b73e7484"
const script = {}
script.render = render

export default script